import React, { useState, useEffect, useContext } from "react";
import { globalInfo } from "../../App";
import AdminHeader from "./AdminHeader";
import AdminNavigation from "./AdminNavigation";
import AdminFooter from "./AdminFooter";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { getSingleSelectManufacturerDropdown, getSingleSelectSitesDropdown, submitFormData } from "../../Utils/adminFunctions";

let AdminAddParticipantGroup = () => {
  const {ip_address} = useContext(globalInfo);
  const [listCompanies, setListCompanies] = useState("");
  const [listSites, setListSites] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [errorCompanyName, setErrorCompanyName] = useState("");
  const [siteName, setSiteName] = useState("");
  const [errorSiteName, setErrorSiteName] = useState("");
  
  useEffect(() => {
    async function fetchAPI1() {
      const response = await getSingleSelectManufacturerDropdown();
      if (response.status === "success") {
        setListCompanies(response.optionItems);
      } else {
        toast.error(response, { autoClose: 1500 });
      }
    }
    fetchAPI1();
  }, []);

  const getSites = async (mID) => {
    if (mID === "") {
      setListSites("");
      return false;
    }
    let bodyFormData = new FormData();
    bodyFormData.append("manufacturer_id", mID);
    const response = await getSingleSelectSitesDropdown(bodyFormData);
    if (response.status === "success") {
      setListSites(response.optionItems);
    } else {
      toast.error(response, { autoClose: 1500 });
    }
  };
  const submitParticipantGroup = async () => {
    let errorRequiredFiled = 0;
    if (companyName === "") {
      setErrorCompanyName("Can not be empty");
      errorRequiredFiled = errorRequiredFiled + 1;
    }
    if (siteName === "") {
      setErrorSiteName("Can not be empty");
      errorRequiredFiled = errorRequiredFiled + 1;
    }
    if (errorRequiredFiled > 0) {
      toast.warning("Required fields are missing ", { autoClose: 1500 });
      return false;
    }
    const bodyFormData = new FormData();
    bodyFormData.append("manufacturer_id", companyName);
    bodyFormData.append("site_id", siteName);
    bodyFormData.append("entered_by_ip", ip_address);
    const response = await submitFormData("addParticipantGroup", bodyFormData);
    if (response.status == "success") {
      setCompanyName("");
      setSiteName("");
      setListSites("");
      toast.success(response.message, { autoClose: 1500 });
      window.location.href = `/AdminListParticipantGroups`; // navigate to previous page after success
    } else {
      toast.warning(response.message, { autoClose: 1500 });
    }
  };
  return (
    <div>
      <div className="wrapper">
        <div>
          <ToastContainer />
          <AdminHeader />
          <AdminNavigation />
          <div className="content-wrapper">
            <div className="content-header"></div>
            <section className="content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12">
                    <div className="card card-default">
                      <div className="card-header">
                        <div className="card-tools">
                          <div className="col-md-12">
                            <Link
                              to="/AdminListParticipantGroups"
                              className="btn btn-sm custom-btn-primary"
                            >
                              <i className="fa fa-arrow-left"></i> Back
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                Company Name<i className="text-danger">*</i>
                              </span>
                              <select
                                className={
                                  "form-control" +
                                  (errorCompanyName ? " is-invalid" : "")
                                }
                                id="companyName"
                                name="companyName"
                                value={companyName}
                                onChange={(e) => {
                                  setCompanyName(e.target.value);
                                  setErrorCompanyName("");
                                  getSites(e.target.value);
                                }}
                              >
                                <option value="">Select</option>
                                {listCompanies}
                              </select>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                Site Name<i className="text-danger">*</i>
                              </span>
                              <select
                                className={
                                  "form-control" +
                                  (errorSiteName ? " is-invalid" : "")
                                }
                                id="siteName"
                                name="siteName"
                                value={siteName}
                                onChange={(e) => {
                                  setSiteName(e.target.value);
                                  setErrorSiteName("");
                                }}
                              >
                                <option value="">Select</option>
                                {listSites}
                              </select>
                            </div>
                          </div>

                          <div className="col-md-12">
                            <button
                              type="button"
                              className="btn btn-sm custom-btn-primary pull-right"
                              onClick={submitParticipantGroup}
                            >
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>

          <AdminFooter />
        </div>
      </div>
    </div>
  );
};

export default AdminAddParticipantGroup;
